// extracted by mini-css-extract-plugin
module.exports = {"jobsWrapper":"styles-module--jobsWrapper--3tCaj","emptyWrapper":"styles-module--emptyWrapper--3J16C","title":"styles-module--title--2b1gq"};